import React, { useState } from 'react';
import SiteSelector from '../../../components/siteSelector';
import utils from '../../../utils';
import Tags from '../../../components/tags';

const AddSitesBody = ({ campaignInfo, onChangeCB }) => {
  const [selectedSites, setSelectedSites] = useState(
    campaignInfo?.selectedSites || campaignInfo?.sites ? campaignInfo?.selectedSites || campaignInfo?.sites : []
  );

  const removeSite = tag => {
    let localSelectedSites = utils.deepClone(selectedSites);
    localSelectedSites = localSelectedSites.filter(site => site.id !== tag.id);
    setSelectedSites(localSelectedSites);
    onChangeCB({ ...campaignInfo, selectedSites: localSelectedSites });
  };

  const handleSiteSelection = siteSelection => {
    const localSelectedSites = utils.deepClone(selectedSites);

    if (selectedSites.some(site => site.id === siteSelection.id)) {
      removeSite(siteSelection);
    } else {
      localSelectedSites.push(siteSelection);
      setSelectedSites(localSelectedSites);
      onChangeCB({ ...campaignInfo, selectedSites: localSelectedSites });
    }
  };

  return (
    <>
      <>
        <div className="form-group site-device-section">
          <label>Sites</label>
          <SiteSelector
            onSelection={handleSiteSelection}
            outline
            customLabel={null}
            customSelected={{ label: 'Add a site', value: 'selectASite' }}
          />
        </div>
        <div className="site-tags">
          {selectedSites.map(tag => {
            return (
              <Tags
                key={`tag-${tag.displayName.trim().toLowerCase().replace(/\s+/g, '-')}`}
                value={tag.displayName || tag.id}
                hasCloseButton
                onClose={() => removeSite(tag)}
              />
            );
          })}
        </div>
      </>
    </>
  );
};

export default AddSitesBody;
